<header class="fixed top-0 left-0 right-0 z-50 flex items-center justify-between bg-white px-4 header-safe shadow-sm">

  <!-- Logo -->
  <div class="flex items-center gap-4 sm:pl-10">
    <img [src]="logoSrc" alt="Logo" class="h-8 w-auto cursor-pointer" (click)="goToHome()" />
  </div>

  <div class="flex items-center">
    @for (item of items; track trackByLabel($index, item)) {
    <div class="relative">
        <button
        type="button"
        class="relative overflow-visible cursor-pointer group rounded-lg px-2 py-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-metro-blue focus-visible:ring-offset-2 focus-visible:ring-offset-white transition duration-200 ease-out hover:scale-105 active:scale-95 transform-gpu motion-reduce:transition-none"

        [attr.aria-current]="isItemActive(item) ? 'page' : null"
        (click)="onClick(item)">
        <span
          class="absolute inset-0 rounded-lg bg-metro-blue/10 opacity-0 transition-opacity duration-200 group-hover:opacity-100 group-active:opacity-80 pointer-events-none"
          [class.opacity-100]="isItemActive(item)"></span>
        <span class="relative z-10 flex items-center gap-1">
          @if (item.label) {
          <span class="text-sm font-bold">{{ item.label | abpLocalization | titlecase }}</span>
          }
          @if (item.iconSvg) {
          <span
            class="inline-flex transition-transform duration-200 ease-out group-hover:scale-110 group-active:scale-95 motion-reduce:transition-none"
            [class.scale-110]="isItemActive(item)">
            <app-metro-icon [svg]="item.iconSvg" size="20" [color]="isItemActive(item) ? '#0D1E29' : '#1C2D36'"></app-metro-icon>
          </span>
          }
        </span>
        @if (item.iconSvg && item.iconName === "cart" && cartCount > 0) {
        <span
          class="absolute -top-1 -right-1 bg-red-600 text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center z-10">
          {{ cartCount }}
        </span>
        }
      </button>

      <!-- Dropdown -->
      @if (item.children && isMenuOpen(item.label || item.path || '')) {
      <ul class="absolute right-0 mt-1 w-40 bg-white border border-gray-200 rounded-lg shadow-lg z-20 text-sm pl-0">
        @for (child of item.children; track trackByLabel($index, child)) {
        <li (click)="onClick(child)" class="py-1  hover:bg-gray-100 cursor-pointer text-center">
          {{ child.label | abpLocalization}}
        </li>
        }
      </ul>
      }
    </div>
    }
  </div>
</header>
